var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"influencer-network-create","width":400,"title":"Netzwerk erstellen"}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-network-form',{attrs:{"influencerNetwork":_vm.influencerNetwork,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }